import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {isMobile} from 'react-device-detect';
import { Link, useNavigate } from "react-router-dom";
import { logoutUser,userDetail } from "../../services/actions/Actions";

function Header() {
  const [isOpen,setIsOpen] = useState(0);
  const [username,setUsername] = useState("");
  const [usermob,setUsermob] = useState("");
  const [aepsBalance,setAepsBalance] = useState("");
  const [walletBalance,setWalletBalance] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storeData = useSelector((state) => state.userData);
  
  const showMobileSideMenu = async () => {
        if(isMobile){
            let exists = Object.values(document.body.classList).includes("sidebar-open");
                if(exists){
                    document.body.classList.remove('sidebar-open');
                }else{
                    document.body.classList.add('sidebar-open');
                }
        }else{
            let exists = Object.values(document.body.classList).includes("sidebar-open");
            if(exists){
                document.body.classList.remove('sidebar-open');
                document.body.classList.add('sidebar-close');
            }else{
                document.body.classList.remove('sidebar-close');
                document.body.classList.add('sidebar-open');
            }
        }
    }
    useEffect(()=>{
        if(isMobile){
        document.body.classList.add(
            'main-bg',
            'main-bg-opac', 
            'main-bg-blur', 
            'adminuiux-sidebar-fill-white', 
            'adminuiux-sidebar-boxed', 
            'theme-blue', 
            'roundedui', 
            'bg-r-gradient'
        );
        }else{
            document.body.classList.add(
                'main-bg',
                'main-bg-opac', 
                'main-bg-blur', 
                'adminuiux-sidebar-fill-white', 
                'adminuiux-sidebar-boxed', 
                'theme-blue', 
                'roundedui', 
                'bg-r-gradient',
                'sidebar-open'
            );
        }
    },[])
    useEffect(()=>{
        if(storeData?.isLoggedIn === true){
            setUsername(storeData.data.name);
            setUsermob(storeData.data.mobile);
            setAepsBalance(storeData.data.aeps_balance);
            setWalletBalance(storeData.data.user_balance);
        }
    },[storeData])
    useEffect(()=>{
        let formData = new FormData();
        const localStorageDataStr = localStorage.getItem('token');
        const item = JSON.parse(localStorageDataStr);
        formData.append("api_token", item.token);
        dispatch(userDetail(formData));
    },[])
    const logout = async () => {    
        localStorage.removeItem('token');
        dispatch(logoutUser());
        navigate('/login');
    }
return (
  <header className="adminuiux-header">
  <nav
      className="navbar navbar-expand-lg fixed-top"
      style={{
          backgroundImage: "linear-gradient(to right, white, rgb(0 168 243))",
          top: "-10px"
      }}
  >
      <div className="container-fluid">
          <button
              className="btn btn-link btn-square sidebar-toggler"
              type="button"
              onClick={showMobileSideMenu}
          >
              <i className="sidebar-svg" data-feather="menu" />
          </button>
          <Link className="navbar-brand" to="/dashboard">
              <img
                  data-bs-img="light"
                  src="/images/Kiara Logo without Background.png"
                  alt=""
                  style={{ height: 70, width: 55 }}
              />
              <img
                  data-bs-img="dark"
                  src="/images/Kiara Logo without Background.png"
                  alt=""
              />
              <div className="">
                  <span className="h4" style={{ color: "rgb(0 168 243)" }}>
                      Kiaraa &nbsp;
                  </span>
                  <span className="h4" style={{ color: "rgb(255 202 25)" }}>
                      Pay
                  </span>
                  <p className="company-tagline bold">Transfer &amp; Payments</p>
              </div>
          </Link>
          <div
              className="navbar-collapse right-in-device  collapse"
              id="header-navbar"
          >
              <ul className="navbar-nav mx-lg-3 mb-2 mb-md-0">
                  <li
                      className="nav-item"
                      style={{ marginLeft: 18, fontSize: 12, fontWeight: 700 }}
                  >
                      Wallet
                      <br /> Balance
                  </li>
                  <li className="nav-item">|</li>
                  <li className="nav-item" style={{ fontSize: 28 }}>
                      {walletBalance}
                  </li>
                  <li
                      className="nav-item"
                      style={{ marginLeft: 18, fontSize: 12, fontWeight: 700 }}
                  >
                      Aeps
                      <br /> Balance
                  </li>
                  <li className="nav-item">|</li>
                  <li className="nav-item" style={{ fontSize: 28 }}>
                      {aepsBalance}
                  </li>
                  {/*<li class="nav-item"><a class="nav-link" href="investment-transaction.html">Transaction</a></li>*/}
                  {/*<li class="nav-item"><a class="nav-link" href="investment-blogs.html">News</a></li>*/}
              </ul>
          </div>
          <div
              style={{
                  marginRight: 10,
                  marginTop: 10,
                  fontSize: 13,
                  fontWeight: 700,
                  padding: 5
              }}
          >
              Welcome : {username}
              <br /> Agent Code : KIAR12279
              <br />
              Contact No : {usermob}
          </div>
          <div className="ms-auto">                        
              <div className="dropdown d-inline-block">
                  <a
                      className="dropdown-toggle btn btn-link btn-square btn-link-header style-none no-caret px-0"
                      id="userprofiledd"
                      onClick={() => setIsOpen(!isOpen)}
                  >
                      <div className="row gx-0 d-inline-flex">
                          <div className="col-auto align-self-center">
                              
                                  <img
                                  className="avatar avatar-28 rounded-circle coverimg align-middle"
                                      src="/images/user-6.jpg"
                                      alt=""
                                      id="userphotoonboarding2"
                                  />
                              
                          </div>
                      </div>
                  </a>
                  
                  <div
                      className={`dropdown-menu dropdown-menu-end width-300 pt-0 px-0 sm-mi-45px ${isOpen ? 'show' : ''}`}
                      style={{position: "absolute",left: "-261px"}}
                      aria-labelledby="userprofiledd"
                  >

                      <div className="px-2 mt-2">
                          <div>
                              <a className="dropdown-item" href="/user/kyc-info">
                                  <i data-feather="user" className="avatar avatar-18 me-1" />{" "}
                                  My Profile
                              </a>
                          </div>
                          <div>
                              <a className="dropdown-item" href="user-bank-list">
                                  <div className="row g-0">
                                      <div className="col align-self-center">
                                          <i
                                              data-feather="layout"
                                              className="avatar avatar-18 me-1"
                                          />{" "}
                                          Bank Detail
                                      </div>
                                  </div>
                              </a>
                          </div>

                          <div>
                              <a className="dropdown-item" href="profile-edit">
                                  <i
                                      data-feather="settings"
                                      className="avatar avatar-18 me-1"
                                  />{" "}
                                  Account Setting
                              </a>
                          </div>
                          <div>
                              <a
                                  className="dropdown-item theme-red"
                                  href="#"
                                  onClick={logout}
                              >
                                  <i data-feather="power" className="avatar avatar-18 me-1" />{" "}
                                  Logout
                              </a>
                              <form
                                  id="logout-form"
                                  action="logout"
                                  method="POST"
                                  className="d-none"
                              >
                                  <input
                                      type="hidden"
                                      name="_token"
                                      defaultValue="D4MMnG44EBV6yC223rVDL2C2RVJ8bJi6XQUumwtP"
                                  />{" "}
                              </form>
                          </div>
                      </div>
                  </div>
                  
              </div>
              <button
                  className="navbar-toggler btn btn-link btn-link-header btn-square btn-icon collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#header-navbar"
                  aria-controls="header-navbar"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
              >
                  <i data-feather="more-vertical" className="openbtn" />{" "}
                  <i data-feather="x" className="closebtn" />
              </button>
          </div>
      </div>
  </nav>
</header>
  );
}

export default Header;